var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3504",
  "data-name": "Group 3504",
  transform: "translate(-2010 -2014)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "AdCopy_Available_Background",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(2010 2014)",
  fill: "#4398ed"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3276",
  "data-name": "Group 3276"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-package",
  "data-name": "Icon feather-package",
  transform: "translate(2012 2015.979)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M10.5,8V4a1,1,0,0,0-.5-.865l-3.5-2a1,1,0,0,0-1,0l-3.5,2A1,1,0,0,0,1.5,4V8a1,1,0,0,0,.5.865l3.5,2a1,1,0,0,0,1,0l3.5-2A1,1,0,0,0,10.5,8Z",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M1.635,3.48,6,6.005,10.365,3.48",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M6,11.04V6",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M2013.871,2019.3l4.056-2.292,3.784,2.292-3.67,2.216Z",
  fill: "#fff"
})))));
export default __webpack_public_path__ + "static/media/InventoryAvailable.c576f4f3.svg";
export { SvgComponent as ReactComponent };